<template>
  <div
    class="grid w-full max-w-md mx-auto mt-6"
    style="grid-template-rows: auto 1fr"
  >
    <div class="flex items-end justify-between pb-4">
      <div class="text-lg font-bold">History</div>
      <div>
        <action-button @click="clearLog" type="outline"> Clear </action-button>
      </div>
    </div>
    <div class="relative">
      <div
        class="absolute inset-0 w-full h-full overflow-x-hidden overflow-y-auto"
      >
        <transition-group name="log-list" tag="div" class="space-y-3">
          <button
            class="w-full px-3 py-2 text-sm text-left bg-white border-2 rounded-md dark:bg-gray-800 focus:outline-none"
            :class="{
              'border-gray-300 dark:border-gray-700 dark:text-gray-300':
                (rollIsMax(rollResult) == false &&
                  rollIsMin(rollResult) == false) ||
                highlightMinAndMaxRolls == false,
              'border-green-600 text-green-600 dark:text-green-100':
                rollIsMax(rollResult) && highlightMinAndMaxRolls,
              'border-red-600 text-red-600 dark:text-red-100':
                rollIsMin(rollResult) && highlightMinAndMaxRolls,
            }"
            v-for="(rollResult, index) in log"
            :key="log.length - (index - 1)"
            @click="
              roll({
                notation: rollResult.rollData.notation,
                name: rollResult.name,
              })
            "
          >
            <div class="flex items-center">
              <div class="flex flex-col flex-1">
                <div class="font-semibold">{{ rollResult.name }}</div>
                <div class="mt-1 font-semibold text-gray-600 dark:text-white">
                  {{ rollResult.rollData.output }}
                </div>
              </div>
              <div class="px-3 ml-2 text-xl font-bold text-center text-white">
                {{ rollResult.rollData.total }}
              </div>
            </div>
          </button>
        </transition-group>
      </div>
    </div>
  </div>
</template>

<script>
import { call, get } from "vuex-pathify";

import helpers from "../helpers";

import ActionButton from "@/components/inputs/ActionButton";

export default {
  name: "LogBox",
  components: {
    ActionButton,
  },
  computed: {
    log: get("log"),
    highlightMinAndMaxRolls: get("highlightMinAndMaxRolls"),
  },
  methods: {
    roll: call("roll"),
    clearLog: call("clearLog"),
    rollIsMax: helpers.rollIsMax,
    rollIsMin: helpers.rollIsMin,
  },
};
</script>
